// WATER SOURCE
export const GET_WATER_SOURCES = '/water_source/query';
export const GET_WATER_SOURCE = '/water_source/';
export const POST_WATER_SOURCE = '/water_source/';
export const PUT_WATER_SOURCE = '/water_source/';
export const DELETE_WATER_SOURCE = '/water_source/';
export const CHECK_WATER_SOURCE_EXISTS = '/water_source/query';
